import { render, staticRenderFns } from "./JobSafetyPrintPage.vue?vue&type=template&id=70bd4634"
import script from "./JobSafetyPrintPage.vue?vue&type=script&lang=js"
export * from "./JobSafetyPrintPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports